import { connect } from 'react-redux';
import { setQuestionnaireStateAction } from '../../actions/home';
import Home from '../../components/marketing/home';

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => ({
  setQuestionnaireStateAction: (item) => dispatch(setQuestionnaireStateAction(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
